import { render, staticRenderFns } from "./reportFeeDetailRoom.vue?vue&type=template&id=f8b45be8&scoped=true"
import script from "./reportFeeDetailRoom.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailRoom.vue?vue&type=style&index=0&id=f8b45be8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b45be8",
  null
  
)

export default component.exports